<!--  ******************************************************  -->
<!--  ADD or UPDATE CHARGER DIALOG                           -->
<!--    - Allows the customerUser to insert or update a charger      -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
    {{'CHARGER.ADD' | translate}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="mat-typography dialogBody">


  <form class="example-form" #putCharger="ngForm">

    <!--  ************************************  -->
    <!--             CHARGER NAME               -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'CHARGER.NAME' | translate}}</mat-label>
      <input matInput required #name="ngModel" type="text" name="name" [(ngModel)]="data.charger.name">
      <mat-error *ngIf="name.invalid">
        {{'CHARGER.NAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
      </mat-error>
    </mat-form-field>


    <!--  ************************************  -->
    <!--             CHARGER LABEL               -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'CHARGER.LABEL' | translate}}</mat-label>
      <input matInput required #label="ngModel" type="text" name="label" [(ngModel)]="data.charger.label">
      <mat-error *ngIf="label.invalid">
        {{'CHARGER.LABEL_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
      </mat-error>
    </mat-form-field>

    <!--  ************************************  -->
    <!--            CHARGER   POWER             -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'CHARGER.POWER' | translate}}</mat-label>
      <input matInput #wattPower="ngModel" type="number" name="wattPower" [min]="0" [(ngModel)]="data.charger.wattPower">
      <div fxFlex fxLayoutGap="5px" matSuffix style="margin-right:15px; align-items: center; display:flex; color:grey">
        <mat-icon>offline_bolt</mat-icon>
        <span>Watt</span>
      </div>
      <mat-error *ngIf="wattPower.invalid">
        {{'CHARGER.POWER_FIELD' | translate}} <strong>{{'COMMON.IS_IN_WRONG_FORMAT' | translate}}</strong>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="putCharger!.invalid!" (click)="saveCharger(data.charger)">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
